import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import FileFolder from '@material-ui/icons/Folder';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Typography from '@material-ui/core/Typography';

import Icon from '../Common/Icon/index';

import styles from './styles';
import ListItemText from '@material-ui/core/ListItemText';

const SelectableList = List; //TODO makeSelectable(List);

// TODO make pure

class JobProfileDrilldown extends React.Component {
  state = {
    // jobProfile: {},
  };

  // componentWillMount() {
  //   this.props.fetchJobProfiles();
  // }

  handleSelectJobProfile = (evt, jobProfileId) => {
    console.log('handleSelectJobProfile', jobProfileId);
    const jobProfile = this.props.jobProfiles.find((jp) => jp.id === jobProfileId);
    // this.setState({
    //   jobProfile,
    // });
    // console.log('calling onChange', jobProfile);
    this.props.onChange(jobProfile);
  };

  renderJobProfileListItem = (selected) => (jobProfile) => {
    // console.log('renderItem', jobProfile, selected);
    return (<ListItem
      key={jobProfile.id}
      value={jobProfile}
      selected={selected && jobProfile.id === selected.id}
      onClick={() => this.props.onChange(jobProfile)}
    >
      <ListItemIcon>
        <FileFolder/>
      </ListItemIcon>
      <ListItemText
        primary={jobProfile.name}
      />
      <ListItemSecondaryAction>
        <ChevronRightIcon style={styles.stageIcon}/>
      </ListItemSecondaryAction>
    </ListItem>);
  }

  renderJobProfileStageListItem = (stage) => {
    return (<ListItem
      key={stage.id}
    >
      <ListItemIcon>
        <Icon size={30} name={stage.icon || 'barcode'}/>
      </ListItemIcon>
      <ListItemText primary={stage.name} secondary={stage.description}/>
    </ListItem>);
  }

  renderJobProfileStages = (stages = []) => {
    return (<Grid item xs={6}>
      <Typography variant="caption">Stages</Typography>
      <List>
        {stages.map(this.renderJobProfileStageListItem)}
      </List>
    </Grid>);
  }

  render() {
    const jobProfile = this.props.value || {};
    console.log('jobProfiles', this.props.jobProfiles);
    console.log('jobProfile', jobProfile);
    return (<Grid container spacing={8}>
      <Grid item xs={6}>
        <Typography variant="caption">Job Profiles</Typography>
        <SelectableList
          onChange={this.handleSelectJobProfile}>
          {this.props.jobProfiles.map(this.renderJobProfileListItem(jobProfile))}
        </SelectableList>
      </Grid>

      {this.renderJobProfileStages(jobProfile.stages)}
    </Grid>);
  }
}

JobProfileDrilldown.propTypes = {
  // jobProfile: PropTypes.object,
  // fetchJobProfiles: PropTypes.func.isRequired,
  jobProfiles: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default JobProfileDrilldown;

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({
//     fetchJobProfiles: fetchJobProfilesRoutine.trigger,
//   }, dispatch);
// }
//
// function mapStateToProps(state) {
//   return {
//     jobProfiles: toJS(state.getIn(['jobprofiles', 'jobProfiles', 'data'])),
//   };
// }
//
// export default connect(mapStateToProps, mapDispatchToProps)(JobProfileDrilldown);



// WEBPACK FOOTER //
// ./src/components/JobProfileDrilldown/index.js